exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-block {\n  padding: 0px 0px 0px 0px;\n  margin: 0px 0px 0px 0px;\n}\n.list-block .item-title.label{\n  width: 40;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c6ade300","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/popups/services/CMServiceActivation.vue
// module id = 1168
// module chunks = 2